import { LocalGithubUser } from 'types';

export const defaultUser: LocalGithubUser = {
  login: 'PacificaElise',
  id: 97551426,
  avatar: 'https://avatars.githubusercontent.com/u/97551426?v=4',
  name: 'Tatiana Ivanova',
  company: null,
  blog: 'https://tatianaivanovaportfolio.netlify.app',
  location: 'Belarus, Gomel',
  bio: 'Frontend Developer: HTML5, CSS3, JavaScript ES6, Typescript, Git, Sass, React JS, Next.js, Redux, Redux Toolkit, Node.js, Ajax, Webpack, MobX.',
  twitter: null,
  repos: 46,
  followers: 3,
  following: 1,
  created: '2022-01-11T18:48:11Z',
};
